/**
 * Merges soft OCR line wraps for book-like prose while preserving
 * paragraph breaks and obvious structural lines.
 */
export function mergeSoftWrappedBookLines(rawText: string): string {
  const lines = rawText.replace(/\r\n?/g, '\n').split('\n')
  const merged: string[] = []

  const startsWithLowercase = (value: string) => /^[("'„«]*[a-ząćęłńóśźż]/.test(value)
  const endsSentence = (value: string) => /[.!?]["'”’»)]?$/.test(value)

  for (const line of lines) {
    const trimmed = line.trim()

    if (!trimmed) {
      merged.push('')
      continue
    }

    const prevIndex = merged.length - 1
    const prev = prevIndex >= 0 ? merged[prevIndex] : null
    const shouldTryMerge =
      !!prev &&
      prev.trim().length > 0 &&
      !endsSentence(prev.trim()) &&
      startsWithLowercase(trimmed) &&
      !/^[-–—]\s/.test(trimmed)

    if (!shouldTryMerge) {
      merged.push(trimmed)
      continue
    }

    if (/[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż]-$/.test(prev)) {
      merged[prevIndex] = `${prev.slice(0, -1)}${trimmed}`
    } else {
      merged[prevIndex] = `${prev} ${trimmed}`
    }
  }

  return merged.join('\n')
}

